export default "__VITE_ASSET__DlSTs87k__"